import React from 'react';

const EstimateCard = ({ level = 'Best', price, materials, form, image}) => {
  return (
    <div className="sdc_estimate_card">
      <div className="img_wrapper">
        <img className="estimate_image" src={image} alt={`${level} deck example.`}/>
      </div>
      <div className="sdc_estimate_details">
        <span className="level">{level}</span>
        <span className="price">
        {price ? (<p>${price.toFixed(0)}</p>) : null}
        </span>
        <span>Includes:</span>
        <ul className="features">
          <li>{materials.decking.label}</li>
          { form.steps ? (<li>{materials.steps.label}</li>) : null }
          { form.railing ? (<li>{materials.railing.label}</li>) : null }
        </ul>
      </div>
    </div>
  );
}

export default EstimateCard;